<template>
	<div class="job-premedia">
		<add-item-button 
			v-if="canCreateItems"
			centered
			size="large"
			label="Add Pre-Media Row"
			@click.native="addRow"/>

		<template v-if="premedia.length">
			<job-premedia-group 
				v-for="(item, index) in premedia"
				:key="`premedia-row-${index}`"
				:id="item.id"
				:index="index"
				:type="item.type"
				:shoes="item.shoes"
				:images="item.images"
				:can-edit="canEditItems"
				:can-approve="canApproveItems"
				:can-view-approved="canViewApproved"
				/>	
		</template>

		<template v-else>
			<p>This job has no premedia</p>
		</template>
	</div>
</template>

<script>
	import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'

	import {
			VUEX_PREMEDIA_GET_JOB_PREMEDIA_ROWS,
			VUEX_PREMEDIA_ADD_ROW } from '@/store/constants/premedia'

	import {
        MILESTONEDATA
    } from '@/store/modules/config/stub_milestone_data'

	import MilestoneBuilder from '@/js/milestoneBuilder'

	import AddItemButton from '@/components/ui/_global/Add_Item_Button.vue'
	import JobPremediaGroup from '@/components/ui/Jobs/Job_Premedia_PremediaGroup.vue'

	export default {
		name: 'job-premedia',

		components: {
			'job-premedia-group' : JobPremediaGroup,
			'add-item-button' : AddItemButton
		},

		props: {
			canCreate: {
				type: Boolean,
				required: false,
				default: null
			},
			canEdit: {
				type: Boolean,
				required: false,
				default: null
			},
			canApprove: {
				type: Boolean,
				required: false,
				default: null
			},
			canViewApproved: {
				type: Boolean,
				required: false,
				default: true
			}
		},

		data:() => ({
			// premediaWatched:[]
		}),
		
		computed: {
			...mapState({
				job: state => state.jobs.job,
				jobDeptOptions: state => state.jobs.job.international_subdepartment,
				premedia: state => state.premedia.premediaRows,
				milestoneOffset: state => state.properties.jobMilestoneDateOffsets,
				blackoutDates: state => state.properties.orgBlackoutDates,
			}),

			...mapGetters({
				findEnumItem: 'getJobEnumItem',
				findEnumItemValue: 'getJobEnumItemValue',
				findEnumItemValueByKey: 'getJobEnumItemValueByKey',
				getJobEnumItemValue: 'getJobEnumItemValue',
				getJobEnumItem: 'getJobEnumItem',
				currentUserHasPerm: 'currentUserHasPerm',
			}),

			canCreateItems() {
				return this.canCreate !== null ? 
						this.canCreate : 
						this.currentUserHasPerm(SILA_PERMISSION_JOBS_JOB_PREMEDIA_CREATE)
			},
			canEditItems() { 
				return this.canEdit !== null ? 
						this.canEdit : 
						this.currentUserHasPerm(SILA_PERMISSION_JOBS_JOB_PREMEDIA_UPDATE)
			},
			canApproveItems() { 
				return this.canApprove !== null ? 
						this.canApprove : 
						this.currentUserHasPerm(SILA_PERMISSION_JOBS_JOB_PREMEDIA_UPDATE)
			},
			/*canViewApprovedItems() { 
				return this.canViewApproved !== null ?
						this.canViewApproved : true
			}*/
		},

		mounted() {
			if (this.job.id) {
                this.getCurrentPremedia()
            }

			this.MB = new MilestoneBuilder(MILESTONEDATA, this.blackoutDates)
			// this.MB = new MilestoneBuilder(this.milestoneOffset, this.blackoutDates)
		},

		methods: {
			...mapActions({
				getCurrentPremedia: VUEX_PREMEDIA_GET_JOB_PREMEDIA_ROWS,
                addPremediaRow: VUEX_PREMEDIA_ADD_ROW
			}),

			addRow() {
				if (this.premedia.length == 0) this.saveUpdateProp()
				this.addPremediaRow()
			},

			getNewMilestones() {
				let dept = this.getJobEnumItem('jobDepartments', this.job.department)
				let type = this.findEnumItem('jobTypes', this.job.type)

				let premedia = true

				let submittedDate = this.job.date_submitted

				return this.MB.getMilestones(dept, type, premedia, null, submittedDate)
			},

			saveUpdateProp() {
				let props = {}
				let milestonesData = this.getNewMilestones()
				let extractedData = {}
				milestonesData.forEach(i => extractedData[i.prop] = i.data)

				props = {
					...extractedData,
					priority_id: this.findEnumItemValueByKey('jobPriorities', 'Standard', 'name', 'id'),
				}

				this.$nextTick(() => {
					this.$store.dispatch('VUEX_PREMEDIA_JOB_UPDATE_PROP', props )
				})
			},
		}
	}
</script>